import { render, staticRenderFns } from "./BtnRecriarToken.vue?vue&type=template&id=009b86fe&"
import script from "./BtnRecriarToken.vue?vue&type=script&lang=js&"
export * from "./BtnRecriarToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports